import React, { useContext, useEffect } from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui'

import {
    Card,
    CardContent,
    CardHeader,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography
} from '@material-ui/core';

import { 
    Select,
    FieldError
} from './../../../../common'

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';

import { SapTableNames, LocalTableNames } from '../../../../../helpers';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
}));

export const TaxForm = (props) => {
    const classes = useStyles();

    const {        
        state,
    } = useContext(CustomerRequestContext)

    const { 
        values,
        setFieldValue,
        isSavingRequest
    } = useContext(TabsContext);

    const getTaxClassificationOptions = (taxClassifications) => {
        if(taxClassifications && taxClassifications.length > 0) {
            return taxClassifications.map(x => ({ value: x.name, label: `(${x.name}) ${x.description}` }));
        } else {
            return [{ value: "", label: "No available values" }];
        }
    }

    const getTaxCategoryIndex = (taxCategory) => {
        if(taxCategory && values && values.accountReceivable && 
            values.accountReceivable.taxCategories && 
            values.accountReceivable.taxCategories.length > 0){
                const index = values.accountReceivable.taxCategories.findIndex(x => x.taxCategoryName === taxCategory.name
                    && x.countryKey === taxCategory.countryKey)

                if(index){
                    return index;
                }
            }

        return 0
    }

    return (
        <Card>
            <CardHeader title="Tax Categories"/>
            <CardContent>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Country Code</TableCell>
                                <TableCell>Country Name</TableCell>
                                <TableCell>Tax Category</TableCell>
                                <TableCell>Tax Classification</TableCell>
                                <TableCell>Tax Description</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {state.taxCategories && state.taxCategories.length > 0 && 
                                values.accountReceivable && 
                                values.accountReceivable.taxCategories &&
                                values.accountReceivable.taxCategories.length > 0 &&
                                state.taxCategories.map((taxCategory, index) => {
                                    return(
                                        <TableRow key={index}>
                                            <TableCell>
                                                <Typography>{index}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography>{taxCategory.countryKey}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography>{taxCategory.countryName}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography>{taxCategory.name}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name={`accountReceivable.taxCategories[${getTaxCategoryIndex(taxCategory)}].taxClassificationName`}
                                                    size="small"
                                                    label="Tax classification"
                                                    disabled={props.disabled}
                                                    options={getTaxClassificationOptions(taxCategory.classifications)}/>
                                                <FieldError 
                                                    name={`accountReceivable.taxCategories[${getTaxCategoryIndex(taxCategory)}].taxClassificationName`}
                                                    errors={state.errors} 
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Typography>{taxCategory.description}</Typography>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
}